const CheckIcon = () => (
    <svg className="location-verification-check" viewBox="0 0 24 24" aria-hidden>
        <path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
    </svg>
);

export default CheckIcon;
